import { useCallback, useLayoutEffect, useRef } from "react";

// Stable subscription callback, updated only after a committed render. Useful
// for timers/listeners that must not restart when their business state changes.
export const useLatestCallback = (callback) => {
  const latest = useRef(callback);
  useLayoutEffect(() => { latest.current = callback; }, [callback]);
  return useCallback((...args) => latest.current(...args), []);
};